import React, { useEffect } from 'react';
import { useGameContext } from '../contexts/GameContext';
import kinksData from '../kinks.json';

const CardsMode = () => {
  const { cardOptions, setSelectedTask, setShowTaskText, generateCardOptions } = useGameContext();

  // Ensure we have cards when component mounts
  useEffect(() => {
    if (cardOptions.length === 0) {
      generateCardOptions();
    }
  }, []); // Empty dependency array ensures this runs only once when component mounts

  const selectCard = (task) => {
    setSelectedTask(task);
    setShowTaskText(true);
  };

  function getKinkNames(task) {
    return task.kinks.map(kinkId => kinksData[kinkId].emoji).join(' ');
  }

  return (
    <div className="cards-container">
      <h3>Select a Card</h3>
      {cardOptions.length === 0 ? (
        <p>Loading cards...</p>
      ) : (
        <div className="cards-grid">
          {cardOptions.map((task, index) => (
            <div
              key={index}
              className="card"
              onClick={() => selectCard(task)}
            >
              <div className="card-content">
                <h4>Card {index + 1}</h4>
                <p className="card-kinks">{task.kinks.length > 0 ? getKinkNames(task) : 'Other'}</p>
                <p>Level: {task.level}</p>
                {task.time_in_seconds && <p>Timer: {task.time_in_seconds}s</p>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CardsMode;
